import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { INSIGHTS as SEED_INSIGHTS } from "../lib/content";
import ArticleRenderer from "../components/ArticleRenderer";
import MiniLeadForm from "../components/MiniLeadForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function InsightArticle() {
  const { slug } = useParams();
  const [article, setArticle] = useState(() => SEED_INSIGHTS.find((a) => a.slug === slug) || null);

  useEffect(() => {
    axios.get(`${API}/insights/${slug}`).then((r) => setArticle(r.data)).catch(() => {});
  }, [slug]);

  if (!article) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-32 text-center">
        <h1 className="font-display text-4xl">Article not found</h1>
        <Link to="/insights" className="btn-secondary mt-6 inline-flex">Back to Insights</Link>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16" data-testid={`insight-${slug}`}>
      <Link to="/insights" className="inline-flex items-center gap-2 text-sm text-zinc-600 hover:text-[#1D4ED8]">
        <ArrowLeft className="h-4 w-4" /> Back to Insights
      </Link>
      <div className="mt-8 text-xs uppercase tracking-widest text-[#1D4ED8]">{article.category}</div>
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-4 leading-[1.15]">{article.title}</h1>
      <p className="text-lg text-zinc-600 mt-6 leading-relaxed">{article.summary}</p>
      <div className="my-10 border-t border-zinc-200" />
      <ArticleRenderer blocks={article.body} />

      <div className="mt-14">
        <MiniLeadForm
          context={article.category.toLowerCase().includes("plot") ? "plot" : "holiday"}
          title="Apply this to your specific situation."
          sub="Drop your details — we'll call you within 24 hours."
        />
      </div>

      <div className="mt-10 bg-[#EFF6FF] border border-[#1D4ED8]/20 rounded-2xl p-8">
        <div className="font-display text-2xl">Prefer a longer conversation?</div>
        <p className="text-zinc-700 mt-2">The 45-min Clarity Call is structured — and includes review of anything you've been pitched.</p>
        <Link to="/clarity-call" className="btn-primary mt-5">Book a Clarity Call</Link>
      </div>
    </div>
  );
}
